import axios from '@axios';

export default {
	namespaced: true,
	state: {},
	getters: {},
	mutations: {},
	actions: {
		fetchInvitations(ctx, queryParams) {
			return new Promise((resolve, reject) => {
				axios
					.get('/tender-invitations', { params: queryParams })
					.then(response => resolve(response))
					.catch(error => reject(error));
			});
		},
		sendResponse(ctx, { id, payload }) {
			return new Promise((resolve, reject) => {
				axios
					.put(`/invitations/${id}/reply`, payload)
					.then(response => resolve(response))
					.catch(error => reject(error));
			});
		},
	}
}